import { screenSizes } from './useDeviceType'

export const defaultSizes =
  'xs:100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw 3xl:100vw 4xl:100vw'

// This function is used to prevent images from being upscaled
// the maximum requested image size is the actual max width of the source asset
export const notUpscaledDefaultSizes = (maxWidth: number) => {
  const sizes = defaultSizes.split(' ')
  const newSizes = sizes.map((size) => {
    const [key] = size.split(':')
    const responsiveWidth = screenSizes[key as keyof typeof screenSizes]
    if (responsiveWidth > maxWidth) {
      return `${key}:${maxWidth}px`
    }

    return size
  })
  return newSizes.join(' ')
}

export const defaultSizesOptimised =
  'xs:100vw sm:100vw md:50vw lg:50vw xl:50vw 2xl:50vw 3xl:50vw 4xl:50vw'

export const defaultFallbackSizes =
  'xs:50px sm:50px md:50px lg:50px xl:50px 2xl:50px 3xl:50px 4xl:50px'

export const fallbackImageSettings = {
  sizes: defaultFallbackSizes,
  modifiers: {
    quality: 10,
  },
  provider: 'storyblok',
}

export const isSvg = (source: string) =>
  Boolean(source) && String(source).split('.').pop() === 'svg'
